import api from '../../../constants/api';

export const SHOP_PRICE_LIST_REQUEST = '@@shopPriceList/SHOP_PRICE_LIST_REQUEST';
export const SHOP_PRICE_LIST_SUCCESS = '@@shopPriceList/SHOP_PRICE_LIST_SUCCESS';
export const SHOP_PRICE_LIST_FAILURE = '@@shopPriceList/SHOP_PRICE_LIST_FAILURE';

export const fetchShopPriceList = (page, size, filterValues) => ({
    type: SHOP_PRICE_LIST_REQUEST,
    api: api.SHOP_PRICE_LIST.PAGE,
    page,
    size,
    filterValues,
});
